"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GQL_LIST_STORY_ITEM = exports.GQL_UPDATE_CHR = exports.GQL_CREATE_CHR = exports.GQL_UPDATE_USER = exports.GQL_REMOVE_STORY_PROPERTY_FOR_STUDIO = exports.GQL_REMOVE_PLAYER_REPORT2_FUNCTION = exports.GQL_UPDATE_PLAYER_REPORT2_FUNCTION = exports.GQL_CREATE_PLAYER_REPORT2_FUNCTION = exports.GQL_REMOVE_PLAYER_REPORT2_RENDER_BLOCK = exports.GQL_UPDATE_PLAYER_REPORT2_RENDER_BLOCK = exports.GQL_LIST_STORY_PROPERTY_FOR_STUDIO = exports.GQL_CREATE_PLAYER_REPORT2_RENDER_BLOCK = exports.GQL_COPY_PLAYER_REPORT2 = exports.GQL_CANCEL_PUBLISH_PLAYER_REPORT2 = exports.GQL_PUBLISH_PLAYER_REPORT2 = exports.GQL_REMOVE_PLAYER_REPORT2 = exports.GQL_UPDATE_PLAYER_REPORT2 = exports.GQL_CREATE_PLAYER_REPORT2 = exports.GQL_LIST_PLAYER_REPORT2 = exports.GQL_LOAD_PLAYER_REPORT_IDE_DATA = exports.GQL_REMOVE_CHAPTER_FOR_STUDIO = exports.GQL_UPDATE_CHAPTER_FOR_STUDIO = exports.GQL_CREATE_CHAPTER_FOR_STUDIO = exports.GQL_LIST_CHAPTER_MIN = exports.GQL_REMOVE_STORY_HAS_STUDIO_FILE = exports.GQL_UPDATE_STORY_HAS_STUDIO_FILE = exports.GQL_CREATE_STORY_HAS_STUDIO_FILE = exports.GQL_DISCARD_CHAPTER_DRAFT = exports.GQL_DUPLICATE_CHAPTER_DRAFT = exports.GQL_UPSERT_CHAPTER_DRAFT = exports.GQL_GET_CHAPTER_FOR_EDITING_NOVEL = exports.GQL_GET_CHAPTER_FOR_EDITING = exports.GQL_EXPORT_STUDIO_STORY_AS_SHEET = exports.GQL_EXPORT_STUDIO_CHAPTER_AS_SHEET = exports.GQL_LIST_COLOR = exports.GQL_GET_STORY_PLAY_TYPE = exports.GQL_GET_WEB_NOVEL_STORY_FOR_STUDIO = exports.GQL_GET_STORY_FOR_STUDIO = exports.GQL_LIST_SAMPLE_STORY_FOR_STUDIO_V2 = exports.GQL_LIST_STORY_FOR_WRITER_V2 = exports.GQL_LIST_STORY_FOR_WRITER = exports.GQL_LOGIN_WRITER_WITH_EMAIL_FOR_STUDIO = exports.GQL_GET_WRITER_PROFILE_FOR_STUDIO = exports.GQL_UPDATE_STORY_ITEM = exports.GQL_CREATE_STORY_ITEM = exports.GQL_UPDATE_STORY_PROPERTY_FOR_STUDIO = exports.GQL_CREATE_STORY_PROPERTY_FOR_STUDIO = exports.GQL_UPDATE_STORYGAME_FOR_STUDIO = exports.GQL_UPDATE_STORY_FOR_STUDIO = exports.GQL_CREATE_STORY_FOR_STUDIO = void 0;
exports.GQL_LIST_USER_PLAYED_STORY_FOR_STUDIO = exports.GQL_EXPORT_STORY_INFO_AS_SHEET = exports.GQL_REMOVE_ONBOARDINGPOUP = exports.GQL_UPDATE_ONBOARDINGPOPUP = exports.GQL_CREATE_ONBOARDINGPOPUP = exports.GQL_LIST_ONBOARDINGPOPUP = exports.GQL_LIST_STORY_BY_ADMIN = exports.GQL_SEARCH_USER_PLAYER_REPORT2 = exports.GQL_UPDATE_AUTHOR_BY_ADMIN = exports.GQL_UPDATE_USER_BY_ADMIN = exports.GQL_LIST_USER = exports.GQL_SAVE_PUBLIC_RESOURCE_TO_STUDIO_FILE = exports.GQL_LIST_PUBLIC_RESOURCE_FILE = exports.GQL_LIST_PUBLIC_RESOURCE_CATEGORY = exports.defaultPublicResourceFileProps = exports.defaultPublicResourceCategoryProps = exports.GQL_REMOVE_CONTEST_HAS_STORY = exports.GQL_UPDATE_CONTEST_HAS_STORY = exports.GQL_GET_CONTEST_HAS_STORY = exports.GQL_CREATE_CONTEST_HAS_STORY = exports.GQL_LIST_CONTEST_HAS_STORY = exports.GQL_GET_LATEST_WEB_NOVEL_CONTEST = exports.GQL_GET_CURRENT_WEB_NOVEL_CONTEST = exports.GQL_GET_CURRENT_CONTEST = exports.defaultContestHasStoryProps = exports.GQL_UPDATE_ENDING = exports.GQL_UPDATE_BACKGROUND = exports.GQL_GET_TTS_URL = exports.GQL_LIST_TTS_SPEAKER = exports.GQL_LIST_SAMPLE_STORY_FOR_STUDIO = exports.GQL_GET_CHAPTER_DRAFT_ARCHIVE = exports.GQL_EXPORT_STUDIO_STORY_STAT = exports.GQL_CREATE_CHAPTER_BY_CHAPTER_DRAFT_ARCHIVE = exports.GQL_LIST_CHAPTER_DRAFT_ARCHIVE_IN_TRASH = exports.GQL_LIST_CHAPTER_DRAFT_ARCHIVE = exports.GQL_SEND_RESET_LINK_WITH_EMAIL = exports.GQL_UPDATE_CHAPTER_INDEXES = exports.GQL_GET_LAST_TEST_SESSION = exports.GQL_CREATE_TEST_SESSION = exports.GQL_LIST_AUTHOR_FOR_STUDIO = exports.GQL_REMOVE_USER_MANAGING_STORY = exports.GQL_UPDATE_USER_MANAGING_STORY = exports.GQL_CANCEL_PUBLISH_CHAPTER_FOR_STUDIO = exports.GQL_CREATE_USER_MANAGING_STORY = exports.GQL_PUBLISH_CHAPTER_FOR_STUDIO = exports.GQL_LIST_USER_MANAGING_STORY = exports.GQL_LIST_MIN_CHAPTER_FOR_STUDIO = exports.GQL_LIST_WEB_NOVEL_CHAPTER_FOR_STUDIO = exports.GQL_LIST_CHAPTER_FOR_STUDIO = exports.GQL_GET_CHAPTER = void 0;
exports.GQL_CREATE_BUNDLE_BANNER = exports.GQL_CREATE_BANNER = exports.GQL_UPDATE_STORY_PRICE_SETTING_FOR_STUDIO = exports.GQL_STORY_COUNTS_BY_PLAY_TYPE = exports.GQL_CHANGE_CHAPTER_FREE_SETTING = exports.GQL_LIST_CHAPTER_DRAFT = exports.GQL_DELETE_STORY_WEEKDAY = exports.GQL_CREATE_STORY_WEEKDAY = exports.GQL_DELETE_CHAPTER_COMMENT_BY_ADMIN = exports.GQL_LIST_NUM_COMMENT_OF_CHAPTER = exports.GQL_LIST_NUM_PLAY_OF_CHAPTER = exports.GQL_LIST_STORY_WEEKDAY = exports.GQL_LIST_CHAPTER_COMMENT = exports.GQL_LIST_STORY_CONVERSION_RANK_CACHE = exports.GQL_LIST_STORY_RANK_CACHE = exports.GQL_LIST_BLOCK_BOUNCE_STAT_OF_CHAPTER = exports.GQL_GET_NUM_COMMENT_STAT_OF_STORY = exports.GQL_GET_NUM_LIKE_STAT_OF_STORY = exports.GQL_GET_CONVERSION_STAT_OF_STORY = exports.GQL_GET_NUM_PLAY_STAT_OF_STORY = exports.GQL_UPSERT_MAIN_CHR_ONBOARDING_POPUP = exports.GQL_GET_MAIN_CHR_ONBOARDING_POPUP = exports.GQL_GET_LIST_STORY_COUNTS_BY_STUDIO_V2 = exports.GQL_GET_LIST_STORY_COUNTS_BY_STUDIO = exports.GET_MY_BOT_MISS_RULES = exports.GET_MY_BOT_SEQUENCE_BY_NAME = exports.GQL_REMOVE_REMOTE_SCRIPT_PROVIDER = exports.GQL_UPDATE_REMOTE_SCRIPT_PROVIDER = exports.GQL_CREATE_REMOTE_SCRIPT_PROVIDER = exports.GQL_GET_REMOTE_SCRIPT_PROVIDER = exports.GQL_LIST_REMOTE_SCRIPT_PROVIDER = exports.GQL_GET_FALLBACK_REMOTE_SCRIPT_BY_STUDIO = exports.GQL_UPDATE_APP_CONFIG = exports.GQL_GET_APP_CONFIG = exports.GQL_RESET_USER_STUDIO_TUTORIAL_PROGRESS = exports.GQL_LIST_STUDIO_TUTORIAL_COMPLETION = exports.GQL_MARK_USER_STUDIO_TUTORIAL_PROGRESS = exports.defaultStudioTutorialCompletionPopup = exports.GQL_LIST_STUDIO_RELEASE_VERSION = exports.GQL_UPDATE_STUDIO_RELEASE_ITEM = exports.GQL_CREATE_STUDIO_RELEASE_ITEM = exports.GQL_REMOVE_STUDIO_RELEASE_ITEM = exports.GQL_GET_STUDIO_RELEASE_ITEM = exports.GQL_LIST_STUDIO_RELEASE_ITEM = exports.GQL_REMOVE_STUDIO_RELEASE_VERSION = exports.GQL_UPDATE_STUDIO_RELEASE_VERSION = exports.GQL_CREATE_STUDIO_RELEASE_VERSION = exports.GQL_GET_STUDIO_RELEASE_VERSION = exports.GQL_LIST_STUDIO_RELEASE_VERSION_BY_ADMIN = exports.GQL_GET_PLAYER_DATA = void 0;
exports.GQL_TOGGLE_STORY_GAME_SECTION_COUNTRY = exports.GQL_UPDATE_STORY_GAME_SECTION_ORDER = exports.GQL_REMOVE_STORY_GAME_SECTION = exports.GQL_UPDATE_STORY_GAME_SECTION = exports.GQL_CREATE_STORY_GAME_SECTION = exports.GQL_GET_STORY_GAME_SECTION = exports.GQL_GET_ALL_STORY_GAME_SECTIONS = exports.GQL_UPDATE_STORY_GAME_TAB_ORDER = exports.GQL_GET_ALL_STORY_GAME_TABS = exports.GQL_SEARCH_STORY_TAG_FOR_STUDIO = exports.GQL_CREATE_STORY_TAG_FOR_STUDIO = exports.GQL_CREATE_STORY_PREVIEW_FOR_STUDIO = exports.GQL_UPDATE_STORYGAME_BACKGROUND = exports.GQL_CREATE_STORYGAME_BACKGROUND = exports.GQL_CREATE_BACKGROUND = exports.GQL_GET_LIST_STORY_HAS_BACKGROUND = exports.GQL_UPDATE_AD_NETWORK_ACTIVATION_FOR_STUDIO = exports.GQL_GET_AD_NETWORK_ACTIVATION_FOR_STUDIO = exports.GQL_DELETE_AD_NETWORK_ACTIVATION_FOR_STUDIO = exports.GQL_CREATE_AD_NETWORK_ACTIVATION_FOR_STUDIO = exports.GQL_LIST_AD_NETWORK_ACTIVATION_FOR_STUDIO = exports.GQL_UPDATE_STORY_PRICE_SETTING = exports.GQL_LIST_NOTICE_FILTERED_TIMELEAP_EN = exports.GQL_LIST_NOTICE_FILTERED_TIMELEAP_KO = exports.GQL_STORY_PRICE_SETTING = exports.GQL_GET_SERVICE_SYSTEM_LANGUAGES = exports.GQL_GET_SERVICE_COUNTRIES = exports.GQL_UPDATE_STORY_BUNDLE_COUNTRIES = exports.GQL_GET_STORY_BUNDLE_COUNTRIES_INFO = exports.GQL_GET_ALL_CONTENTS_LANGUAGES = exports.GQL_DELETE_BOTTOM_BANNER = exports.GQL_UPDATE_BOTTOM_BANNER = exports.GQL_GET_BOTTOM_BANNER = exports.GQL_CREATE_BOTTOM_BANNER = exports.GQL_LIST_BOTTOM_BANNER_FOR_ADMIN = exports.GQL_GET_PRESIGNED_URL_FOR_STORY_IMPORT = exports.GQL_GET_LAST_CHAPTER_INDEX_BY_STORY = exports.GQL_GET_MONTHLY_BUNDLE = exports.GQL_DELETE_MONTHLY_BUNDLE = exports.GQL_UPDATE_MONTHLY_BUNDLE = exports.GQL_CREATE_MONTHLY_BUNDLE = exports.GQL_LIST_MONTHLY_BUNDLE = exports.GQL_LIST_BUNDLE_BANNER = exports.GQL_LIST_BANNER = exports.GQL_UPDATE_BUNDLE_BANNER = exports.GQL_UPDATE_BANNER = exports.GQL_GET_BUNDLE_BANNER = exports.GQL_GET_BANNER = exports.GQL_DELETE_BUNDLE_BANNER = exports.GQL_DELETE_BANNER = void 0;
exports.GQL_GET_STORY_SIMPLE_INFO = exports.GQL_TOGGLE_STORY_GAME_VISIBILITY = exports.GQL_TOGGLE_STORY_GAME_LANGUAGE = exports.GQL_TOGGLE_STORY_GAME_COUNTRY = exports.GQL_GET_ALL_STORY_GAME_SECTION_PREVIEWS = exports.GQL_PUBLISH_STORY_GAME_SECTION = exports.GQL_GET_IMAGE_FILE = exports.GQL_CREATE_IMAGE_FILE = void 0;
const createFields = (fieldArray) => fieldArray.join('\n');
const defaultUserProps = `
  userId
  name
  email
  isDev
  priv
  updateToAuthorAt
  authorName
  authorEmail
  phone
  banReason
  bannedAt
  canExportStory
  isTester
  isInternalAuthor
  profileFile {
    link
  }
  ssoLogins {
    ssoProvider
  }
  numCompleteTutorial
  authorType
`;
const defaultStoryProps = `
  storyId
  name
  aProjId
  publishedAt
  createdAt
  isFinished
  finishedAt
  onHiatus
  defaultFirstName
  defaultLastName
  topic
  shortDesc
  oneLineDesc
  targetAge
  storyDetailInfo
  canPublish
  totalNumOfChapterComments
  numBlocks
  numChars
  numSens
  stats
  numBlocksDraft
  numCharsDraft
  numSensDraft
  statsDraft
  isSample
  isReadOnly
  canUseAchievement
  canUserPlayerReport
  isContest
  genre
  sectionType
  isOriginal
  isFixMainChrName
  playType
  refStoryId
  refStory { name }
  mainImageFile { link }
  previewImageFile { link }
  introImageFile { link }
  mainCharacterImageFile { link }
  mainCharacterPortraitFile { link }
  wideImageFile { link }
  teaserVideoFile { link }
  bannerImageFile { link }
  isAdult
  isShowHome
  storygameId
  originalInteractiveStory {
    storyId  
  }
`;
const defaultStoryGameProps = `
  storygameCoverImageFile {
    link
  }
  isStorygameHidden
  storygameReleaseDate
  storygamePreviews {
    storyPreviewId
    fileType
    file {
      link
    }
  }
  storyTags {
    storyTagId
    name
  }
`;
const defaultStoryPropertyProps = `
  propId
  propName
  propNameRaw
  desc
  propType
  maxValue
  imageFile { link }
  unit
  isUsed
  isMain
  showOrder
  displayPropName
  unit
  isPrimary
`;
const defaultStoryItemProps = `
  storyItemId
  storyId
  name
  desc
  imageFileId
  isHidden
  createdAt
  updatedAt
  imageFile {
    link
  }
  displayName
`;
const defaultChapterProps = `
  chapterId
  chapterScript
  publishedAt
  willPublishAt
  updatedAt
  chapterIndex
  storyId
  name
  customId
  numBlocks
  numChars
  numSens
  stats
  numBlocksDraft
  numCharsDraft
  numSensDraft
  statsDraft
  draft {
    bundle
    epubFile {
      link
      fileName
      size
      createdAt
    }
  }
  willFreeAtRaw
  freedAtRaw
  freeDependencyChapterIndex
  freeDependencyPeriod
  isAdult
`;
const defaultEndingProps = `
  endingId
  name
  customId
  chapterId
  collectionDescription
  showOrder
  imageFile { link }
  previewImageFile { link }
  isFinal
  arrivalRate
  rateLevel
  realArrivalRate
  displayName
`;
const defaultStoryDetailProps = `
  properties {
    ${defaultStoryPropertyProps}
  }
  studio {
    allEndings {
      ${defaultEndingProps}
    }
    playerReportCSSLink
  }
`;
const defaultChrProps = `
  chrId
  name
  displayName
  imageFile {
    link
  }
  main
  color
  defaultFirstName
  defaultLastName
  portraitFile {
    link
  }
`;
const defaultUserManagingStory = `
  umsId
  user {
    email
    authorName
    name
  }
  userId
  role
`;
const defaultOnboardingPopup = `
  popupId
  type
  characterId
  description
  onlyName
  showOrder
  status
`;
exports.GQL_CREATE_STORY_FOR_STUDIO = `
mutation createStoryForStudio($data: StoryPropsInput!) {
  createStoryForStudio(data: $data) {
    ${defaultStoryProps}
    allChapters {
      ${defaultChapterProps}
    }
  }
}
`;
exports.GQL_UPDATE_STORY_FOR_STUDIO = `
mutation updateStory($data: StoryPropsInput!) {
  updateStory(data: $data) {
    ${defaultStoryProps}
    ${defaultStoryGameProps}
  }
}
`;
exports.GQL_UPDATE_STORYGAME_FOR_STUDIO = `
mutation updateStorygame($data: UpdateStorygameInput!) {
  updateStory(data: $data) {
    ${defaultStoryGameProps}
  }
}
`;
exports.GQL_CREATE_STORY_PROPERTY_FOR_STUDIO = `
mutation createStoryPropertyForStudio($data: StoryPropertyCreationInput!) {
  createStoryPropertyForStudio(data: $data) {
    ${defaultStoryPropertyProps}
  }
}
`;
exports.GQL_UPDATE_STORY_PROPERTY_FOR_STUDIO = `
mutation updateStoryPropertyForStudio($data: StoryPropertyUpdateInput!) {
  updateStoryPropertyForStudio(data: $data) {
    ${defaultStoryPropertyProps}
  }
}
`;
exports.GQL_CREATE_STORY_ITEM = `
mutation createStoryItem($data: StoryItemCreationInput!) {
  createStoryItem(data: $data) {
    ${defaultStoryItemProps}
  }
}
`;
exports.GQL_UPDATE_STORY_ITEM = `
mutation updateStoryItem($data: StoryItemUpdateInput!) {
  updateStoryItem(data: $data) {
    ${defaultStoryItemProps}
  }
}
`;
exports.GQL_GET_WRITER_PROFILE_FOR_STUDIO = `
query {
  getUser {
    ${defaultUserProps}
  }
}`;
exports.GQL_LOGIN_WRITER_WITH_EMAIL_FOR_STUDIO = `
mutation loginWriterWithEmailForStudio($data: EmailLogin!) {
  loginWriterWithEmailForStudio(data: $data) {
    me {
      ${defaultUserProps}
    }
    token
  }
}
`;
exports.GQL_LIST_STORY_FOR_WRITER = `
query listStoryForWriter($data: ListableStoryInput!) {
  listStoryForWriter(data: $data) {
    list {
      ${defaultStoryProps}
      allChapters {
          chapterId
          publishedAt
          willPublishAt
          chapterIndex
      }
    }
    totalCount
    page
    pageSize
  }
}`;
exports.GQL_LIST_STORY_FOR_WRITER_V2 = `
query listStoryForWriterV2($data: ListableStoryForWriterInput!) {
  listStoryForWriterV2(data: $data) {
    list {
      ${defaultStoryProps}
      allChapters {
          chapterId
          publishedAt
          willPublishAt
          chapterIndex
      }
    }
    totalCount
    page
    pageSize
  }
}`;
exports.GQL_LIST_SAMPLE_STORY_FOR_STUDIO_V2 = `
query listSampleStoryForStudioV2($data: ListableStoryForWriterInput!) {
  listSampleStoryForStudioV2(data: $data) {
    list {
      ${defaultStoryProps}
      allChapters {
          chapterId
          publishedAt
          willPublishAt
          chapterIndex
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
const chapterPropsForList = `
  ${defaultChapterProps}
  defaultEnding {
    customId
  }
  endings {
    ${defaultEndingProps}
    storyProperties {
      storyProp {
        propName
        propNameRaw
        propType
        maxValue
        imageFile {
          link
        }
        showOrder
      }
      customImageFile {
        link
      }
    }
  }
  choices {
    choiceId
    name
    choice1PropName
    choice2PropName
    choice3PropName
    choice4PropName
    choice5PropName
  }
  primaryProperty {
    propId
    displayPropName
    propName
    imageFile {
      link
    }
  }
`;
exports.GQL_GET_STORY_FOR_STUDIO = `
query loadChapterForStudio($data: SingleIDInput!) {
  getStoryV3(data: $data) {
    ${defaultStoryProps}
    ${defaultStoryDetailProps}
    languageCode
    language {
      display
      code
    }
    bundleStories {
      storyId
      language {
          code
          display
      }
    } 
    serviceCountries {
      code
    }
    bundleId
    bundle {
      storyLanguages {
        code
        display
      }
    }
    backgrounds {
      shfId
      name
      file {
        fileType
        link
      }
      fileId
      displayName
      storygameBackgrounds {
        shfId
        platformType
        fileId
        file {
          link
        }
      }
    }
    characters {
      ${defaultChrProps}
      onboardingPopups {
        ${defaultOnboardingPopup}
      }
    }
    mainCharacterImageFile {
      link
    }
    mainCharacterPortraitFile {
      link
    }
    userProps
    studioFiles {
      fileId
      fileName
      link
      width
      height
      storyId
      fileType
      resName
      displayName
    }
    allChapters {
      ${chapterPropsForList}
    }
    storyItems {
      storyItemId
      name
      isHidden
      imageFile {
        fileId
        link
      }
    }
    aEventDefs {
      aEventDefId 
      name
      description
      isAchievement
      badges {
        aBadgeId
        name
        description
        display
        displayLocked
        customData
        imageLink
        imageLockedLink
        sortOrder
        hideBeforeAcquire
      }
    }
    originalInteractiveStory {
      storyId
    }
    ${defaultStoryGameProps}
  }
}`;
exports.GQL_GET_WEB_NOVEL_STORY_FOR_STUDIO = `
query getStory($data: SingleIDInput!) {
  getStoryV3(data: $data) {
    ${defaultStoryProps}
    languageCode
    language {
      display
      code
    }
    bundleStories {
      storyId
      language {
          code
          display
      }
    } 
    serviceCountries {
      code
    }
    bundleId
    bundle {
      storyLanguages {
        code
        display
      }
    }
  }
}`;
exports.GQL_GET_STORY_PLAY_TYPE = `
query getStory($data: SingleIDInput!) {
  getStoryV3(data: $data) {
    playType
  }
}`;
exports.GQL_LIST_COLOR = `
query listColor($data: ListableColorInput!) {
  listColor(data: $data) {
    list {
      colorId
      name
      hex
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_EXPORT_STUDIO_CHAPTER_AS_SHEET = `
mutation exportStudioChapterAsSheet($data: ExportStudioChapterAsSheetInput!) {
  exportStudioChapterAsSheet(data: $data) {
    ok
  }
}
`;
exports.GQL_EXPORT_STUDIO_STORY_AS_SHEET = `
mutation exportStudioStoryAsSheet($data: ExportStudioStoryAsSheetInput!) {
  exportStudioStoryAsSheet(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_CHAPTER_FOR_EDITING = `
query getChapterForEditing($data: SingleIDInput!) {
  getChapter(data: $data) {
    ${chapterPropsForList}
  }
}`;
exports.GQL_GET_CHAPTER_FOR_EDITING_NOVEL = `
query getChapterForEditingNovel($data: SingleIDInput!) {
  getChapter(data: $data) {
    ${defaultChapterProps}
    chapterScript
    draft {
      bundle
      epubFile {
        link
        fileName
        size
        createdAt
      }
      epubFileId
    }
    epubFile {
      link
      fileName
      size
      createdAt
    }
    epubFileId
    contentType
    chapterScript
  }
}`;
exports.GQL_UPSERT_CHAPTER_DRAFT = `
mutation upsertChapterDraft($data: ChapterDraftUpsertInput!) {
  upsertChapterDraft(data: $data) {
    isSaved
    isApplied
    errorsOnApplying
  }
}
`;
exports.GQL_DUPLICATE_CHAPTER_DRAFT = `
mutation duplicateChapterDraft($data: SingleIDInput!) {
  duplicateChapterDraft(data: $data) {
    ok
  }
}
`;
exports.GQL_DISCARD_CHAPTER_DRAFT = `
mutation discardChapterDraft($data: SingleIDInput!) {
  discardChapterDraft(data: $data) {
    ok
  }
}
`;
exports.GQL_CREATE_STORY_HAS_STUDIO_FILE = `
mutation createStoryHasStudioFile($data: StoryHasStudioFileCreationInput!) {
  createStoryHasStudioFile(data: $data) {
    fileId
    fileName
    link
    width
    height
    storyId
    fileType
    resName
  }
}
`;
exports.GQL_UPDATE_STORY_HAS_STUDIO_FILE = `
mutation updateStoryHasStudioFile($data: StoryHasStudioFileUpdateInput!) {
  updateStoryHasStudioFile(data: $data) {
    fileId
    fileName
    link
    width
    height
    storyId
    fileType
    resName
    displayName
  }
}
`;
exports.GQL_REMOVE_STORY_HAS_STUDIO_FILE = `
mutation removeStoryHasStudioFile($data: SingleIDInput!) {
  removeStoryHasStudioFile(data: $data) {
    ok
  }
}
`;
exports.GQL_LIST_CHAPTER_MIN = `
query listChapter($data: ListableChapterInput!) {
  listChapter(data: $data) {
    list {
      chapterId
      customId
      name
      chapterIndex
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_CHAPTER_FOR_STUDIO = `
mutation createChapter($data: ChapterCreationInput!) {
  createChapter(data: $data) {
    ${defaultChapterProps}
    chapterScript
  }
}
`;
exports.GQL_UPDATE_CHAPTER_FOR_STUDIO = `
mutation updateChapterForStudio($data: ChapterPropsInput!) {
  updateChapterForStudio(data: $data) {
    ${defaultChapterProps}
  }
}
`;
exports.GQL_REMOVE_CHAPTER_FOR_STUDIO = `
mutation removeChapterForStudio($data: SingleIDInput!) {
  removeChapterForStudio(data: $data) {
    ok
  }
}
`;
exports.GQL_LOAD_PLAYER_REPORT_IDE_DATA = `
query loadPlayerReportIDEData($data: SingleIDInput!) {
  getPlayerReport2(data: $data) {
    prId
    updatedAt
    name
    code
    sampleData
    ogTitle
    ogDesc
    ogImageFile { link }
  }
  listPlayerReport2RenderBlock(data: {page: 1, pageSize: 1000}) {
    list {
      prbId
      name
      desc
      code
      codeSample
      sampleData
    }
  }
  listPlayerReport2Function(data: {page: 1, pageSize: 1000}) {
    list {
      prfId
      name
      desc
      code
      codeSample
      paramDesc
    }
  }
}`;
const defaultPlayerReport2Props = `
  createdAt
  updatedAt
  prId
  name
  code
  sampleData
  storyId
  ogTitle
  ogDesc
  ogImageFile { link }
`;
exports.GQL_LIST_PLAYER_REPORT2 = `
query listPlayerReport2($data: ListablePlayerReport2Input!) {
  listPlayerReport2(data: $data) {
    list {
      ${defaultPlayerReport2Props}
    }
    totalCount
    page
    pageSize
    activeReportId
  }
}
`;
exports.GQL_CREATE_PLAYER_REPORT2 = `
mutation createPlayerReport2($data: PlayerReport2CreationInput!) {
  createPlayerReport2(data: $data) {
    ${defaultPlayerReport2Props}
  }
}
`;
exports.GQL_UPDATE_PLAYER_REPORT2 = `
mutation updatePlayerReport2($data: PlayerReport2UpdateInput!) {
  updatePlayerReport2(data: $data) {
    ${defaultPlayerReport2Props}
  }
}
`;
exports.GQL_REMOVE_PLAYER_REPORT2 = `
mutation removePlayerReport2($data: SingleIDInput!) {
  removePlayerReport2(data: $data) {
    ok
  }
}
`;
exports.GQL_PUBLISH_PLAYER_REPORT2 = `
mutation publishPlayerReport2($data: SingleIDInput!) {
  publishPlayerReport2(data: $data) {
    ${defaultPlayerReport2Props}
  }
}
`;
exports.GQL_CANCEL_PUBLISH_PLAYER_REPORT2 = `
mutation cancelPublishPlayerReport2($data: SingleIDInput!) {
  cancelPublishPlayerReport2(data: $data) {
    ok
  }
}
`;
exports.GQL_COPY_PLAYER_REPORT2 = `
mutation copyPlayerReport2($data: CopyPlayerReport2Input!) {
  copyPlayerReport2(data: $data) {
    ${defaultPlayerReport2Props}
  }
}
`;
const defaultPlayerReport2RenderBlockProps = `
  createdAt
  updatedAt
  prbId
  name
  desc
  code
  codeSample
  sampleData
`;
exports.GQL_CREATE_PLAYER_REPORT2_RENDER_BLOCK = `
mutation createPlayerReport2RenderBlock($data: PlayerReport2RenderBlockCreationInput!) {
  createPlayerReport2RenderBlock(data: $data) {
    ${defaultPlayerReport2RenderBlockProps}
  }
}
`;
exports.GQL_LIST_STORY_PROPERTY_FOR_STUDIO = `
query listStoryPropertyForStudio($data: ListableStoryPropertyInput!) {
  listStoryPropertyForStudio(data: $data) {
    list {
      ${defaultStoryPropertyProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_UPDATE_PLAYER_REPORT2_RENDER_BLOCK = `
mutation updatePlayerReport2RenderBlock($data: PlayerReport2RenderBlockUpdateInput!) {
  updatePlayerReport2RenderBlock(data: $data) {
    ${defaultPlayerReport2RenderBlockProps}
  }
}
`;
exports.GQL_REMOVE_PLAYER_REPORT2_RENDER_BLOCK = `
mutation removePlayerReport2RenderBlock($data: SingleIDInput!) {
  removePlayerReport2RenderBlock(data: $data) {
    ok
  }
}
`;
const defaultPlayerReport2FunctionProps = `
  createdAt
  updatedAt
  prfId
  name
  desc
  code
  codeSample
  paramDesc
`;
exports.GQL_CREATE_PLAYER_REPORT2_FUNCTION = `
mutation createPlayerReport2Function($data: PlayerReport2FunctionCreationInput!) {
  createPlayerReport2Function(data: $data) {
    ${defaultPlayerReport2FunctionProps}
  }
}
`;
exports.GQL_UPDATE_PLAYER_REPORT2_FUNCTION = `
mutation updatePlayerReport2Function($data: PlayerReport2FunctionUpdateInput!) {
  updatePlayerReport2Function(data: $data) {
    ${defaultPlayerReport2FunctionProps}
  }
}
`;
exports.GQL_REMOVE_PLAYER_REPORT2_FUNCTION = `
mutation removePlayerReport2Function($data: SingleIDInput!) {
  removePlayerReport2Function(data: $data) {
    ok
  }
}
`;
exports.GQL_REMOVE_STORY_PROPERTY_FOR_STUDIO = `
mutation removeStoryPropertyForStudio($data: SingleIDInput!) {
  removeStoryPropertyForStudio(data: $data) {
    ok
  }
}
`;
exports.GQL_UPDATE_USER = `
mutation updateAuthor($data: UpdateAuthorInput!) {
  updateAuthor(data: $data) {
    ${defaultUserProps}
  }
}
`;
exports.GQL_CREATE_CHR = `
mutation createChr($data: ChrPropsInput!) {
  createChr(data: $data) {
    ${defaultChrProps}
  }
}
`;
exports.GQL_UPDATE_CHR = `
mutation updateChr($data: ChrPropsInput!) {
  updateChr(data: $data) {
    ${defaultChrProps}
  }
}
`;
exports.GQL_LIST_STORY_ITEM = `
query listStoryItem($data: ListableStoryItemInput!) {
  listStoryItem(data: $data) {
    list {
     ${defaultStoryItemProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_GET_CHAPTER = `
query getChapter($data: SingleIDInput!) {
  getChapter(data: $data) {
      chapterId
      publishedAt
      willPublishAt
      updatedAt
      chapterIndex
      storyId
      name
      customId
      willFreeAtRaw
      freedAtRaw
      freeDependencyChapterIndex
      freeDependencyPeriod
  }
}
`;
exports.GQL_LIST_CHAPTER_FOR_STUDIO = `
query listChapterForStudio($data: ListableChapterInput!) {
  listChapterForStudio(data: $data) {
    list {
      chapterId
      publishedAt
      willPublishAt
      updatedAt
      chapterIndex
      storyId
      name
      customId
      isAdult
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_WEB_NOVEL_CHAPTER_FOR_STUDIO = `
query listChapterForStudio($data: ListableChapterInput!) {
  listChapterForStudio(data: $data) {
    list {
      ${defaultChapterProps}
      chapterScript
      epubFile {
        link
      }
      epubFileId
      contentType
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_MIN_CHAPTER_FOR_STUDIO = `
query listChapterForStudio($data: ListableChapterInput!) {
  listChapterForStudio(data: $data) {
    list {
      chapterId
      chapterIndex
      name
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_USER_MANAGING_STORY = `
query listUserManagingStory($data: ListableUserManagingStoryInput!) {
  listUserManagingStory(data: $data) {
    list {
      ${defaultUserManagingStory}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_PUBLISH_CHAPTER_FOR_STUDIO = `
mutation publishChapterForStudio($data: PublishChapterForStudioInput!) {
  publishChapterForStudio(data: $data) {
    ok
  }
}
`;
exports.GQL_CREATE_USER_MANAGING_STORY = `
mutation createUserManagingStory($data: UserManagingStoryCreationInput!) {
  createUserManagingStory(data: $data) {
    umsId
  }
}
`;
exports.GQL_CANCEL_PUBLISH_CHAPTER_FOR_STUDIO = `
mutation cancelPublishChapterForStudio($data: SingleIDInput!) {
  cancelPublishChapterForStudio(data: $data) {
    ok
  }
}
`;
exports.GQL_UPDATE_USER_MANAGING_STORY = `
mutation updateUserManagingStory($data: UserManagingStoryUpdateInput!) {
  updateUserManagingStory(data: $data) {
    umsId
  }
}
`;
exports.GQL_REMOVE_USER_MANAGING_STORY = `
mutation removeUserManagingStory($data: UserManagingStoryRemoveInput!) {
  removeUserManagingStory(data: $data) {
    ok
  }
}
`;
exports.GQL_LIST_AUTHOR_FOR_STUDIO = `
query listAuthorForStudio($data: ListableAuthorForStudioInput!) {
  listAuthorForStudio(data: $data) {
    list {
      ${defaultUserProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
const defaultTestSessionProps = `
  createdAt
  updatedAt
  testSessionId
  playData
  storyId
  chapterId
`;
exports.GQL_CREATE_TEST_SESSION = `
mutation createTestSession($data: TestSessionCreationInput!) {
  createTestSession(data: $data) {
    ${defaultTestSessionProps}
  }
}
`;
exports.GQL_GET_LAST_TEST_SESSION = `
query getLastTestSession($data: SingleIDInput!) {
  getLastTestSession(data: $data) {
    ${defaultTestSessionProps}
  }
}
`;
exports.GQL_UPDATE_CHAPTER_INDEXES = `
mutation updateChapterIndexes($data: UpdateChapterIndexesInput!) {
  updateChapterIndexes(data: $data) {
    ok
  }
}
`;
exports.GQL_SEND_RESET_LINK_WITH_EMAIL = `
mutation sendResetLinkWithEmail($data: SingleEmailInput!) {
  sendResetLinkWithEmail(data: $data) {
    ok
  }
}
`;
// script
const defaultDraftArchiveProps = `
  createdAt
  updatedAt
  cdaId
  chapterId
  customId
  chapterName
  storyId
  userId
  numBlocks
  numChars
  numSens
  stats
  bundle
`;
exports.GQL_LIST_CHAPTER_DRAFT_ARCHIVE = `
query listChapterDraftArchive($data: ListableChapterDraftArchiveInput!) {
  listChapterDraftArchive(data: $data) {
    list {
      createdAt
      updatedAt
      cdaId
      chapterId
      customId
      storyId
      chapterName
    }
    totalCount
    page
    pageSize 
  }
}
`;
exports.GQL_LIST_CHAPTER_DRAFT_ARCHIVE_IN_TRASH = `
query listChapterDraftArchiveInTrash($data: ListableChapterDraftArchiveInTrashInput!) {
  listChapterDraftArchiveInTrash(data: $data) {
    list {
      createdAt
      cdaId
      chapterName
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_CHAPTER_BY_CHAPTER_DRAFT_ARCHIVE = `
mutation createChapterByChapterDraftArchive($data: SingleIDInput!) {
  createChapterByChapterDraftArchive(data: $data) {
    ok
  }
}
`;
exports.GQL_EXPORT_STUDIO_STORY_STAT = `
mutation exportStudioStoryStat($data: SingleStringIDInput!) {
  exportStudioStoryStat(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_CHAPTER_DRAFT_ARCHIVE = `
query getChapterDraftArchive($data: SingleIDInput!) {
  getChapterDraftArchive(data: $data) {
    cdaId
    bundle
  }
}
`;
exports.GQL_LIST_SAMPLE_STORY_FOR_STUDIO = `
query listSampleStoryForStudio($data: ListableStoryInput!) {
  listSampleStoryForStudio(data: $data) {
    list {
      ${defaultStoryProps}
      allChapters {
          chapterId
          publishedAt
          willPublishAt
          chapterIndex
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_TTS_SPEAKER = `
query listTtsSpeaker($data: ListableTtsSpeakerInput!) {
  listTtsSpeaker(data: $data) {
    list {
      ttsSpeakerId
      ttsServerSpeakerId
      name
      ageGroupList
      pitchList
      speechList
      extraCharacter
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_GET_TTS_URL = `
mutation getTtsUrl($data: ConvertTextToVoiceInput!) {
  getTtsUrl(data: $data) {
    url
  }
}
`;
exports.GQL_UPDATE_BACKGROUND = `
mutation updateBackground($data: StoryHasBackgroundPropsInput!) {
  updateBackground(data: $data) {
      shfId
      storyId
      fileId
      name
      displayName
      file {
        link
      }
      storygameBackgrounds {
        shfId
        platformType
        storyId
        name
        fileId
        file {
          link
        }
      }
  }
}
`;
exports.GQL_UPDATE_ENDING = `
mutation updateEnding($data: EndingPropsInput!) {
  updateEnding(data: $data) {
    ${defaultEndingProps}
  }
}
`;
//
// Contest
//
exports.defaultContestHasStoryProps = `
  createdAt
  updatedAt
  chsId
  storyId
  selectedNumbers
  version
`;
exports.GQL_GET_CURRENT_CONTEST = `
query getCurrentContest {
  getCurrentContest {
    version
    startAt
    endAt
  }
}
`;
exports.GQL_GET_CURRENT_WEB_NOVEL_CONTEST = `
query getCurrentEpubContest {
  getCurrentEpubContestForStudio {
    version
    startAt
    endAt
  }
}
`;
exports.GQL_GET_LATEST_WEB_NOVEL_CONTEST = `
query getLatestEpubContest {
  getLatestEpubContest {
    version
    title
    startAt
    endAt
    link
  }
}
`;
exports.GQL_LIST_CONTEST_HAS_STORY = `
query listContestHasStory($data: ListableContestHasStoryInput!) {
  listContestHasStory(data: $data) {
    list {
      ${exports.defaultContestHasStoryProps}
      story {
        name
        author {
          authorName
        }
        showOrder
        isFinished
        genre
        playType
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_CONTEST_HAS_STORY = `
mutation createContestHasStory($data: ContestHasStoryCreationInput!) {
  createContestHasStory(data: $data) {
    ${exports.defaultContestHasStoryProps}
  }
}
`;
exports.GQL_GET_CONTEST_HAS_STORY = `
mutation getContestHasStory($data: SingleIDInput!) {
  getContestHasStory(data: $data) {
    ${exports.defaultContestHasStoryProps}
  }
}
`;
exports.GQL_UPDATE_CONTEST_HAS_STORY = `
mutation updateContestHasStory($data: ContestHasStoryUpdateInput!) {
  updateContestHasStory(data: $data) {
    ${exports.defaultContestHasStoryProps}
  }
}
`;
exports.GQL_REMOVE_CONTEST_HAS_STORY = `
mutation removeContestHasStory($data: SingleIDInput!) {
  removeContestHasStory(data: $data) {
    ok
  }
}
`;
//
// PublicResource
//
exports.defaultPublicResourceCategoryProps = `
  createdAt
  updatedAt
  pcrId
  type
  name
  showOrder
`;
exports.defaultPublicResourceFileProps = `
  fileId
  fileName
  resourceType
  categoryId
  link
`;
exports.GQL_LIST_PUBLIC_RESOURCE_CATEGORY = `
query listPublicResourceCategory($data: ListablePublicResourceCategoryInput!) {
  listPublicResourceCategory(data: $data) {
    list {
      ${exports.defaultPublicResourceCategoryProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_PUBLIC_RESOURCE_FILE = `
query listPublicResourceFile($data: ListablePublicResourceFileInput!) {
  listPublicResourceFile(data: $data) {
    list {
      ${exports.defaultPublicResourceFileProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_SAVE_PUBLIC_RESOURCE_TO_STUDIO_FILE = `
mutation savePublicResourceToStudioFile($data: SavePublicResourceFileToStudioFileInput!) {
  savePublicResourceToStudioFile(data: $data) {
    fileId
    fileName
    link
    width
    height
    storyId
    fileType
    resName
    displayName
  }
}
`;
//
// User In Admin Page
//
exports.GQL_LIST_USER = `
query listUser($data: ListableUserInput!) {
  listUser(data: $data) {
    list {
      ${defaultUserProps}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_UPDATE_USER_BY_ADMIN = `
mutation updateUserByAdmin($data: UserPropsInputByAdmin!) {
  updateUserByAdmin(data: $data) {
    userId
  }
}
`;
exports.GQL_UPDATE_AUTHOR_BY_ADMIN = `
mutation updateAuthorByAdmin($data: UpdateAuthorByAdminInput!) {
  updateAuthorByAdmin(data: $data) {
    userId
  }
}
`;
exports.GQL_SEARCH_USER_PLAYER_REPORT2 = `
query searchUserPlayerReport2($data: SearchUserPlayerReport2Input!) {
  searchUserPlayerReport2(data: $data) {
    list {
      uprId
      playingVersion
      extractData
      ending {
        name
      }
      userPlayedStory {
        user {
          userId
          name
          authorName
        }
        finishedAt
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_STORY_BY_ADMIN = `
query listStoryByAdminForStudio($data: ListableStoryByAdminForStudioInput!) {
  listStoryByAdminForStudio(data: $data) {
    list {
      createdAt
      storyId
      name
      author {
        authorName
      }
      genre
      sectionType
      publishedAt
      willPublishAt
      isFinished
      playType
      studioPriceSetting
      bundle {
        stories {
          name
          language {
            display
          }
        }
        storyLanguages {
          display
        }
      }
      serviceCountries {
        code
      }
      language {
        display
      }
    }
    page
    pageSize
    totalCount
  }
}
`;
exports.GQL_LIST_ONBOARDINGPOPUP = `
query listOnboardingPopup($data: ListableOnboardingPopupInput!) {
  listOnboardingPopup(data: $data) {
    list {
      ${defaultOnboardingPopup}
    }
    page
    pageSize
    totalCount
  }
}
`;
exports.GQL_CREATE_ONBOARDINGPOPUP = `
mutation createOnboardingPopup($data: CreateOnboardingPopupInput!) {
  createOnboardingPopup(data: $data) {
    ${defaultOnboardingPopup}
  }
}
`;
exports.GQL_UPDATE_ONBOARDINGPOPUP = `
mutation updateOnboardingPopup($data: UpdateOnboardingPopupInput!) {
  updateOnboardingPopup(data: $data) {
    ${defaultOnboardingPopup}
  }
}
`;
exports.GQL_REMOVE_ONBOARDINGPOUP = `
mutation deleteOnboardingPopup($data: SingleIDInput!) {
  deleteOnboardingPopup(data: $data) {
    ok
  }
}
`;
exports.GQL_EXPORT_STORY_INFO_AS_SHEET = `
mutation exportStoryInfoAsSheet($data: SingleStringIDInput!) {
  exportStoryInfoAsSheet(data: $data) {
    ok
  }
}
`;
exports.GQL_LIST_USER_PLAYED_STORY_FOR_STUDIO = `
query listUserPlayedStoryForStudio($data: ListableUserPlayedStoryForStudioInput!) {
  listUserPlayedStoryForStudio(data: $data) {
    list {
      upsId
      playingVersion
      finishedAt
      ending {
        name
      }
      user {
        userId
        name
        authorName
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_GET_PLAYER_DATA = `
query getPlayerData($data: SingleIDInput!) {
  getPlayerData(data: $data) {
    sampleData
  }
}
`;
exports.GQL_LIST_STUDIO_RELEASE_VERSION_BY_ADMIN = `
query listStudioReleaseVersionByAdmin($data: ListableStudioReleaseVersionByAdminInput!) {
  listStudioReleaseVersionByAdmin(data: $data) {
    list {
      createdAt
      updatedAt
      srvId
      versionName
      releaseDate
      isHidden
      numItems
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_GET_STUDIO_RELEASE_VERSION = `
query getStudioReleaseVersion($data: SingleIDInput!) {
  getStudioReleaseVersion(data: $data) {  
    createdAt
    updatedAt
    srvId
    versionName
    releaseDate
    isHidden
    numItems
  }
}
`;
exports.GQL_CREATE_STUDIO_RELEASE_VERSION = `
mutation createStudioReleaseVersion($data: StudioReleaseVersionCreationInput!) {
  createStudioReleaseVersion(data: $data) {
    createdAt
    updatedAt
    srvId
    versionName
    releaseDate
    isHidden
    numItems
  }
}
`;
exports.GQL_UPDATE_STUDIO_RELEASE_VERSION = `
mutation updateStudioReleaseVersion($data: StudioReleaseVersionUpdateInput!) {
  updateStudioReleaseVersion(data: $data) {
    createdAt
    updatedAt
    srvId
    versionName
    releaseDate
    isHidden
    numItems  
  }
}
`;
exports.GQL_REMOVE_STUDIO_RELEASE_VERSION = `
mutation removeStudioReleaseVersion($data: SingleIDInput!) {
  removeStudioReleaseVersion(data: $data) {
    ok
  }
}
`;
exports.GQL_LIST_STUDIO_RELEASE_ITEM = `
query listStudioReleaseItem($data: ListableStudioReleaseItemInput!) {
  listStudioReleaseItem(data: $data) {
    list {
      createdAt
      updatedAt
      sriId
      title
      showOrder
      description
      externalLink
      versionId
    }
    page
    pageSize
    totalCount
  }
}
`;
exports.GQL_GET_STUDIO_RELEASE_ITEM = `
query getStudioReleaseItem($data: SingleIDInput!) {
  getStudioReleaseItem(data: $data) {
    createdAt
    updatedAt
    sriId
    title
    showOrder
    description
    externalLink
    versionId
    version {
      versionName
    }
  }
}
`;
exports.GQL_REMOVE_STUDIO_RELEASE_ITEM = `
mutation removeStudioReleaseItem($data: SingleIDInput!) {
  removeStudioReleaseItem(data: $data) {
    ok
  }
}
`;
exports.GQL_CREATE_STUDIO_RELEASE_ITEM = `
mutation createStudioReleaseItem($data: StudioReleaseItemCreationInput!) { 
  createStudioReleaseItem(data: $data) {
    createdAt
    updatedAt
    sriId
    title
    showOrder
    description
    externalLink
    versionId    
  }
}
`;
exports.GQL_UPDATE_STUDIO_RELEASE_ITEM = `
mutation updateStudioReleaseItem($data: StudioReleaseItemUpdateInput!) { 
  updateStudioReleaseItem(data: $data) {
    createdAt
    updatedAt
    sriId
    title
    showOrder
    description
    externalLink
    versionId    
  }
}
`;
exports.GQL_LIST_STUDIO_RELEASE_VERSION = `
query listStudioReleaseVersion($data: ListableStudioReleaseVersionInput!) {
  listStudioReleaseVersion(data: $data) {
    list {
      createdAt
      updatedAt
      srvId
      versionName
      releaseDate
      isHidden
      numItems
      items {
        sriId
        title
        description
        externalLink
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.defaultStudioTutorialCompletionPopup = `
  stcId
  userId
  code
  extra
`;
exports.GQL_MARK_USER_STUDIO_TUTORIAL_PROGRESS = `
mutation markUserStudioTutorialProgress($data: StudioTutorialCompletionCreationInput!) {
  markUserStudioTutorialProgress(data: $data) {
    ${exports.defaultStudioTutorialCompletionPopup}
  }
}
`;
exports.GQL_LIST_STUDIO_TUTORIAL_COMPLETION = `
query listStudioTutorialCompletion {
  listStudioTutorialCompletion {
    list {
      ${exports.defaultStudioTutorialCompletionPopup}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_RESET_USER_STUDIO_TUTORIAL_PROGRESS = `
mutation resetUserStudioTutorialProgress($data: SingleIDInput!) {
  resetUserStudioTutorialProgress(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_APP_CONFIG = `
query appConfig { 
  appConfig {
    rawContestBannerInfo
  }
}
`;
exports.GQL_UPDATE_APP_CONFIG = `
mutation updateAppConfig($data: AppConfigUpdateInput!) {
  updateAppConfig(data: $data) {
    rawContestBannerInfo
  }
}
`;
exports.GQL_GET_FALLBACK_REMOTE_SCRIPT_BY_STUDIO = `
query getFallbackRemoteScriptByStudio($data: GetFallbackRemoteScriptByStudioInput!) {
  getFallbackRemoteScriptByStudio(data: $data) {
    statements
  }
}
`;
exports.GQL_LIST_REMOTE_SCRIPT_PROVIDER = `
query listRemoteScriptProvider($data: ListableRemoteScriptProviderInput!) {
  listRemoteScriptProvider(data: $data) {
    list {
      createdAt
      updatedAt
      remoteScriptProviderId
      remoteScriptType
      provider
      description
      paramsDescription
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_GET_REMOTE_SCRIPT_PROVIDER = `
query getRemoteScriptProvider($data: SingleIDInput!) {
  getRemoteScriptProvider(data: $data) {  
    createdAt
    updatedAt
    remoteScriptProviderId
    remoteScriptType
    provider
    description
    paramsDescription
  }
}
`;
exports.GQL_CREATE_REMOTE_SCRIPT_PROVIDER = `
mutation createRemoteScriptProvider($data: RemoteScriptProviderCreationInput!) {
  createRemoteScriptProvider(data: $data) {
    createdAt
    updatedAt
    remoteScriptProviderId
    remoteScriptType
    provider
    description
    paramsDescription
  }
}
`;
exports.GQL_UPDATE_REMOTE_SCRIPT_PROVIDER = `
mutation updateRemoteScriptProvider($data: RemoteScriptProviderUpdateInput!) {
  updateRemoteScriptProvider(data: $data) {
    createdAt
    updatedAt
    remoteScriptProviderId
    remoteScriptType
    provider
    description
    paramsDescription
  }
}
`;
exports.GQL_REMOVE_REMOTE_SCRIPT_PROVIDER = `
mutation removeRemoteScriptProvider($data: SingleIDInput!) {
  removeRemoteScriptProvider(data: $data) {
    ok
  }
}
`;
exports.GET_MY_BOT_SEQUENCE_BY_NAME = `
query getMyBotSequenceByName($data: GetMyBotSequenceByNameInput!) {
  getMyBotSequenceByName(data: $data) {
    seq
  }
}
`;
exports.GET_MY_BOT_MISS_RULES = `
query getMyBotMissRules($data: GetMyBotMissRulesInput!) {
  getMyBotMissRules(data: $data) {
    missRules {
      input
      count
    }
  }
}
`;
exports.GQL_GET_LIST_STORY_COUNTS_BY_STUDIO = `
query getListStoryCountsByStudio {
  getListStoryCountsByStudio {
    published
    noPublished
    finished
    sample
  }
}
`;
exports.GQL_GET_LIST_STORY_COUNTS_BY_STUDIO_V2 = `
query getListStoryCountsByStudioV2($data: ListableStoryCountsByStudioInput!) {
  getListStoryCountsByStudioV2(data: $data) {
    published
    noPublished
    finished
    sample
  }
}
`;
exports.GQL_GET_MAIN_CHR_ONBOARDING_POPUP = `
query getMainChrOnboardingPopup($data: SingleIDInput!) {
  getMainChrOnboardingPopup(data: $data) {
    ${defaultOnboardingPopup}
  } 
} 
`;
exports.GQL_UPSERT_MAIN_CHR_ONBOARDING_POPUP = `
mutation upsertMainChrOnboardingPopup($data: UpsertMainChrOnboardingPopupInput!) {
  upsertMainChrOnboardingPopup(data: $data) {
    ${defaultOnboardingPopup}
  }
}
`;
exports.GQL_GET_NUM_PLAY_STAT_OF_STORY = `
query getNumPlayStatOfStory($data: GetNumPlayStatOfStoryInput!) {
  getNumPlayStatOfStory(data: $data) {
    total
    latestCount
    changedRate
    changedCount
    list {
      count
      period
      x
      isDrop
      isTop
    }
  }
}
`;
exports.GQL_GET_CONVERSION_STAT_OF_STORY = `
query getConversionStatOfStory($data: GetConversionStatOfStoryInput!) {
  getConversionStatOfStory(data: $data) {
    total
    latestRate
    changedRate
    dataForGraph {
      x
      rate
      isDrop
    }
    list {
      period
      chapter1
      chapter2
      chapter3
      lastChapter
      to2Rate
      to3Rate
      toLastRate
    }
  }
}
`;
exports.GQL_GET_NUM_LIKE_STAT_OF_STORY = `
query getNumLikeStatOfStory($data: GetNumLikeStatOfStoryInput!) {
  getNumLikeStatOfStory(data: $data) {
    total
    latestCount
    changedRate
    changedCount
    list {
      count
      period
      x
      isDrop
      isTop
    }
  }
}
`;
exports.GQL_GET_NUM_COMMENT_STAT_OF_STORY = `
query getNumCommentStatOfStory($data: GetNumCommentStatOfStoryInput!) {
  getNumCommentStatOfStory(data: $data) {
    total
    latestCount
    changedRate
    changedCount
    list {
      count
      period
      x
      isDrop
      isTop
    }
  }
}
`;
exports.GQL_LIST_BLOCK_BOUNCE_STAT_OF_CHAPTER = `
query listBlockBounceStatOfChapter($data: ListableBlockBounceStatOfChapterInput!) {
  listBlockBounceStatOfChapter(data: $data) {
    currentRate
    list {
      blockName
      total
      rate
      ios
      aos
    }
  }
}
`;
exports.GQL_LIST_STORY_RANK_CACHE = `
query listStoryRankCache($data: ListableStoryRankCacheInput!) {
  listStoryRankCache(data: $data) {
    myRank {
      currentRank
      changedRank
      score
      story {
        storyId
        genre
        name
        isFinished
        mainImageFile {
          link
        }
        chapters {
          chapterIndex
          publishedAt
        }
      }
    }
    list {
      currentRank
      changedRank
      score
      story {
        storyId
        genre
        name
        isFinished
        mainImageFile {
          link
        }
        chapters {
          chapterIndex
          publishedAt
        }
      }
    }
  }
}
`;
exports.GQL_LIST_STORY_CONVERSION_RANK_CACHE = `
query listStoryConversionRankCache($data: ListableStoryRankCacheInput!) {
  listStoryConversionRankCache(data: $data) {
    myRank {
      currentRank
      changedRank
      numPlayer
      to2Rate
      to3Rate
      toLastRate
      story {
        storyId
        genre
        name
        isFinished
        mainImageFile {
          link
        }
        chapters {
          chapterIndex
          publishedAt
        }
      }
    }
    list {
      currentRank
      changedRank
      numPlayer
      to2Rate
      to3Rate
      toLastRate
      story {
        storyId
        genre
        name
        isFinished
        mainImageFile {
          link
        }
        chapters {
          chapterIndex
          publishedAt
        }
      }
    }
  }
}
`;
exports.GQL_LIST_CHAPTER_COMMENT = `
query listChapterComment($data: ListableChapterCommentInput!) {
  listChapterComment(data: $data) {
    list {
      createdAt
      ccId
      isBestComment
      content
      numOfLikes
      numOfNestedComments
      chapter {
        chapterIndex
        name
      }
      author {
        name
      }
      imageFile {
        link
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_STORY_WEEKDAY = `
query listStoryWeekday($data: ListableStoryWeekdayInput!) {
  listStoryWeekday(data: $data) {
    list {
      weekday
    }
  }
}
`;
exports.GQL_LIST_NUM_PLAY_OF_CHAPTER = `
query listNumPlayOfChapter($data: ListableNumPlayOfChapterInput!) {
  listNumPlayOfChapter(data: $data) {
    list {
      chapterId
      chapterIndex
      count
    }
  }
}
`;
exports.GQL_LIST_NUM_COMMENT_OF_CHAPTER = `
query listNumCommentOfChapter($data: ListableNumCommentOfChapterInput!) {
  listNumCommentOfChapter(data: $data) {
    list {
      chapterId
      chapterIndex
      count
    }
  }
}
`;
exports.GQL_DELETE_CHAPTER_COMMENT_BY_ADMIN = `
mutation deleteChapterCommentByAdmin($data: SingleIDInput!) {
  deleteChapterCommentByAdmin(data: $data) {
    ok
  }
}
`;
exports.GQL_CREATE_STORY_WEEKDAY = `
mutation createStoryWeekday($data: StoryWeekdayCreationInput!) {
  createStoryWeekday(data: $data) {
    storyWeekdayId
  }
}
`;
exports.GQL_DELETE_STORY_WEEKDAY = `
mutation deleteStoryWeekday($data: StoryWeekdayDeleteInput!) {
  deleteStoryWeekday(data: $data) {
    ok
  }
}
`;
exports.GQL_LIST_CHAPTER_DRAFT = `
query listChapterDraft($data: ListableChapterDraftInput!) {
  listChapterDraft(data: $data) {
    list {
      chapterDraftId
      updatedAt
    }
  }
}
`;
exports.GQL_CHANGE_CHAPTER_FREE_SETTING = `
mutation changeChapterFreeSetting($data: ChangeChapterFreeSettingInput!) {
  changeChapterFreeSetting(data: $data) {
    ok
  }
}
`;
exports.GQL_STORY_COUNTS_BY_PLAY_TYPE = `
query getStoryCountsByPlayType {
  getStoryCountsByPlayType {
    total
    interactive
    epub
  }
}
`;
exports.GQL_UPDATE_STORY_PRICE_SETTING_FOR_STUDIO = `
mutation updateStoryPriceSettingForStudio($data: UpdateStoryPriceSettingForStudioInput!) {
  updateStoryPriceSettingForStudio(data: $data) {
    storyId
    studioPriceSetting
  }
}
`;
//
// 배너
//
const COMMON_BANNER_FIELDS = [
    'createdAt',
    'updatedAt',
    'bannerId',
    'type',
    'storyId',
    'location',
    'targetClient',
    'linkType',
    'title',
    'content',
    'bannerImageFileId',
    'isShow',
    'link',
    'aOSFallbackLink',
    'iOSFallbackLink',
    'langCode',
    'willOpenAt',
    'willCloseAt',
    'state',
];
const BANNER_FULL_SNAPSHOT = `
  ${createFields(COMMON_BANNER_FIELDS)}
  story {
    storyId
    name
    mainImageFile {
      link
    }
    bannerImageFile {
      link
    }
  }
  bannerImageFile {
    link
  }
`;
const COMMON_BUNBLE_BANNER_FIELDS = [
    'createdAt',
    'updatedAt',
    'bundleBannerId',
    'type',
    'storyId',
    'location',
    'targetClient',
    'linkType',
    'title',
    'content',
    'bannerImageFileId',
    'isShow',
    'link',
    'aOSFallbackLink',
    'iOSFallbackLink',
    'countryCode',
    'languageCode',
    'language {display}',
    'willOpenAt',
    'willCloseAt',
    'state',
    'displayLanguages',
];
const BUNDLE_BANNER_FULL_SNAPSHOT = `
  ${createFields(COMMON_BUNBLE_BANNER_FIELDS)}
  story {
    storyId
    name
    mainImageFile {
      link
    }
    bannerImageFile {
      link
    }
  }
  bannerImageFile {
    link
  }
`;
exports.GQL_CREATE_BANNER = `
mutation createBanner($data: BannerCreationInput!) {
  createBanner(data: $data) {
    ${BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_CREATE_BUNDLE_BANNER = `
mutation createBundleBanner($data: BundleBannerCreationInput!) {
  createBundleBanner(data: $data) {
    ${BUNDLE_BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_DELETE_BANNER = `
mutation deleteBanner($data: SingleIDInput!) {
  deleteBanner(data: $data) {
    ok
  }
}
`;
exports.GQL_DELETE_BUNDLE_BANNER = `
mutation deleteBundleBanner($data: SingleIDInput!) {
  deleteBundleBanner(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_BANNER = `
query getBanner($data: SingleIDInput!) {
  getBanner(data: $data) {
    ${BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_GET_BUNDLE_BANNER = `
query getBundleBanner($data: SingleIDInput!) {
  getBundleBanner(data: $data) {
    ${BUNDLE_BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_UPDATE_BANNER = `
mutation updateBanner($data: BannerUpdateInput!) {
  updateBanner(data: $data) {
    ${BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_UPDATE_BUNDLE_BANNER = `
mutation updateBundleBanner($data: BundleBannerUpdateInput!) {
  updateBundleBanner(data: $data) {
    ${BUNDLE_BANNER_FULL_SNAPSHOT}
  }
}
`;
exports.GQL_LIST_BANNER = `
query listBanner($data: ListableBannerInput!) {
  listBanner(data: $data) {
    list {
      ${BANNER_FULL_SNAPSHOT}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_LIST_BUNDLE_BANNER = `
query listBundleBanner($data: ListableBundleBannerInput!) {
  listBundleBanner(data: $data) {
    list {
      ${BUNDLE_BANNER_FULL_SNAPSHOT}
    }
    totalCount
    page
    pageSize
  }
}
`;
//
// 월간 인기작 PD's Pick
//
exports.GQL_LIST_MONTHLY_BUNDLE = `
query listMonthlyBundle($data: ListableMonthlyBundleInput!) {
  listMonthlyBundleByAdmin(data: $data) {
    list {
      monthlyBundleId
      countryCode
      year
      month
      yyyymm
      story {
        name
      }
      storyBundle {
        storyLanguages {
          code
          display
        }
      }
      createdAt
    }
    
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_MONTHLY_BUNDLE = `
mutation createMonthlyBundle($data: MonthlyBundleCreationInput!) {
  createMonthlyBundleByAdmin(data: $data) {
    storyBundleId
  }
}
`;
exports.GQL_UPDATE_MONTHLY_BUNDLE = `
mutation updateMonthlyBundle($data: MonthlyBundleUpdateInput!) {
  updateMonthlyBundleByAdmin(data: $data) {
    storyBundleId
  }
}
`;
exports.GQL_DELETE_MONTHLY_BUNDLE = `
mutation deleteMonthlyBundle($data: SingleIDInput!) {
  deleteMonthlyBundleByAdmin(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_MONTHLY_BUNDLE = `
query getMonthlyBundle($data: SingleIDInput!) {
  getMonthlyBundleByAdmin(data: $data) {
    storyId
    monthlyBundleId
    countryCode
    yyyymm
    story {
      storyId
      name
    }
  }
}
`;
exports.GQL_GET_LAST_CHAPTER_INDEX_BY_STORY = `
query getStory($data: SingleIDInput!) {
  getStoryV3(data: $data) {
    lastPublishedChapterIndex
  }
}
`;
exports.GQL_GET_PRESIGNED_URL_FOR_STORY_IMPORT = `
mutation getPresignedUrlForStoryImportV3($data: GetPresignedUrlForStoryImportV3Input!) {
  getPresignedUrlForStoryImportV3(data: $data){
    hash
    presignedUrl
  }
}
`;
const COMMON_BOTTOM_BANNER_FIELDS = [
    'createdAt',
    'updatedAt',
    'bottomBannerId',
    'title',
    'styleTitle',
    'isShow',
    'webLink',
    'willOpenAt',
    'willCloseAt',
    'state',
];
exports.GQL_LIST_BOTTOM_BANNER_FOR_ADMIN = `
query listBottomBannerForAdmin($data: ListableBottomBannerInput!) {
  listBottomBannerForAdmin(data: $data) {
    list {
      ${createFields(COMMON_BOTTOM_BANNER_FIELDS)}
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_BOTTOM_BANNER = `
mutation createBottomBanner($data: BottomBannerCreationInput!) {
  createBottomBanner(data: $data) {
    ${createFields(COMMON_BOTTOM_BANNER_FIELDS)}
  }
}
`;
exports.GQL_GET_BOTTOM_BANNER = `
query getBottomBanner($data: SingleIDInput!) {
  getBottomBanner(data: $data) {
    ${createFields(COMMON_BOTTOM_BANNER_FIELDS)}
  }
}
`;
exports.GQL_UPDATE_BOTTOM_BANNER = `
mutation updateBottomBanner($data: BottomBannerUpdateInput!) {
  updateBottomBanner(data: $data) {
    ok
  }
}
`;
exports.GQL_DELETE_BOTTOM_BANNER = `
mutation deleteBottomBanner($data: SingleIDInput!) {
  deleteBottomBanner(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_ALL_CONTENTS_LANGUAGES = `
query getAllContentsLanguages {
  getAllContentsLanguagesByAdmin {
    display
    code
  }
}
`;
exports.GQL_GET_STORY_BUNDLE_COUNTRIES_INFO = `
query GetStoryBundleCountriesInfo($data: GetStoryBundleCountriesInfoForStudioInput!){
  getStoryBundleCountriesInfoForStudio(data: $data) {
    serviceCountries { 
      code
    }
    activatedCountries { 
      code
    }
  }
}
`;
exports.GQL_UPDATE_STORY_BUNDLE_COUNTRIES = `
mutation UpdateStoryBundleCountries($data:UpdateStoryBundleCountriesInput!) {
  updateStoryBundleCountries(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_SERVICE_COUNTRIES = `
query getServiceCountries {
  getServiceCountriesByAdmin {
    code
  }
}
`;
exports.GQL_GET_SERVICE_SYSTEM_LANGUAGES = `
query getServiceSystemLanguages {
  getServiceSystemLanguagesByAdmin {
    code
    display
  }
}`;
exports.GQL_STORY_PRICE_SETTING = `
query getStoryPriceSetting($data:GetStoryPriceSettingInput!) {
  getStoryPriceSetting(data: $data) {
    story {
      name
      bundleId
      playType
      onHiatus
      isFinished
      lastChapterIndex
      serviceCountries {
        code
      }
    }
    storyPriceSettingId
    storyId
    countryCode
    isFree
    paidPerChapterActivated
    paidPerChapterSetting
    paidPerStoryActivated
    paidPerStorySetting
    adPerChapterActivated
    adPerChapterSetting
    freedAtPerChapterActivated
    freedAtPerChapterSetting
    waitFreePerChapterActivated
    waitFreePerChapterSetting
    afterSomePeriodFreePerChapterActivated
    afterSomePeriodFreePerChapterSetting
    timeLeapFreePerChapterActivated
    timeLeapFreePerChapterSetting
  }
}
`;
exports.GQL_LIST_NOTICE_FILTERED_TIMELEAP_KO = `
query listNoticeFilteredTimeLeapKo {
  listNoticeByAdmin(data: {
    page: 1
    pageSize: 50
    filter: "타임리프"
  }) {
    list {
      noticeId
      title
    }
  }
}
`;
exports.GQL_LIST_NOTICE_FILTERED_TIMELEAP_EN = `
query listNoticeFilteredTimeLeapEn {
 listNoticeByAdmin(data: {
    page: 1
    pageSize: 50
    filter: "Time Leap"
  }) {
    list {
      noticeId
      title
    }
  }
}
`;
exports.GQL_UPDATE_STORY_PRICE_SETTING = `
mutation updateStoryPriceSetting($data: StoryPriceSettingUpdateInput!){
	updateStoryPriceSetting(data: $data) {
    storyPriceSettingId
    storyId
    countryCode
    isFree
    paidPerChapterActivated
    paidPerChapterSetting
    paidPerStoryActivated
    paidPerStorySetting
    adPerChapterActivated
    adPerChapterSetting
    freedAtPerChapterActivated
    freedAtPerChapterSetting
    waitFreePerChapterActivated
    waitFreePerChapterSetting
    afterSomePeriodFreePerChapterActivated
    afterSomePeriodFreePerChapterSetting
    timeLeapFreePerChapterActivated
    timeLeapFreePerChapterSetting
  }
}
`;
exports.GQL_LIST_AD_NETWORK_ACTIVATION_FOR_STUDIO = `
query($data: ListableAdNetworkActivationInput!) {
  listAdNetworkActivationForStudio(data: $data){
    list {
      adNetworkActivationId
      adId
      isShow
      description
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_AD_NETWORK_ACTIVATION_FOR_STUDIO = `
mutation($data: AdNetworkActivationCreationInput!) {
  createAdNetworkActivationForStudio(data: $data) {
    adId
  }
}
`;
exports.GQL_DELETE_AD_NETWORK_ACTIVATION_FOR_STUDIO = `
mutation($data: SingleIDInput!) {
  deleteAdNetworkActivationForStudio(data: $data) {
    ok
  }
}
`;
exports.GQL_GET_AD_NETWORK_ACTIVATION_FOR_STUDIO = `
query ($data: SingleIDInput!) {
  getAdNetworkActivationForStudio(data: $data) {  
    adNetworkActivationId
    adId
    isShow
    description
  }
}
`;
exports.GQL_UPDATE_AD_NETWORK_ACTIVATION_FOR_STUDIO = `
mutation($data: AdNetworkActivationUpdateInput!) {
  updateAdNetworkActivationForStudio(data: $data) {
    adId
    isShow
  }
}
`;
exports.GQL_GET_LIST_STORY_HAS_BACKGROUND = `
query getListStoryHasBackground($data: ListableStoryHasBackgroundInput!) {
  listStoryHasBackground(data: $data) {
    list {
      shfId
      name
      displayName
      file {
        link
        fileId
        fileName
      }
      storygameBackgrounds {
        shfId
        platformType
        file {
          link
        }
      }
    }
    totalCount
    page
    pageSize
  }
}
`;
exports.GQL_CREATE_BACKGROUND = `
mutation createBackground($data: StoryHasBackgroundCreationInput!) {
  createBackgroundForStudio(data: $data) {
    shfId
    storyId
    fileId
    name
    displayName
    file {
      link
    }
    storygameBackgrounds {
      shfId
      platformType
      storyId
      name
      fileId
      file {
        link
      }
    }
  }
}
`;
const StorygameBackgroundProps = `
 shfId
 fileId
 file {
   link
 }
 storyHasBackground {
   shfId
   storyId
   fileId
   name
   displayName
   file {
     link
   }
   storygameBackgrounds {
     shfId
     platformType
     storyId
     name
     fileId
     file {
       link
     }
   } 
 }
`;
exports.GQL_CREATE_STORYGAME_BACKGROUND = `
mutation createStorygameBackground($data: StorygameBackgroundCreationInput!) {
  createStorygameBackground(data: $data) {
    ${StorygameBackgroundProps}
  }
}
`;
exports.GQL_UPDATE_STORYGAME_BACKGROUND = `
mutation updateStorygameBackground($data: StorygameBackgroundUpdateInput!) {
  updateStorygameBackground(data: $data) {
    ${StorygameBackgroundProps}
  }
}
`;
exports.GQL_CREATE_STORY_PREVIEW_FOR_STUDIO = `
mutation createStoryPreviewForStudio($data: StoryPreviewCreationInput!) {
  createStoryPreviewForStudio(data: $data) {
    storyPreviewId
    file {
      link
    }
  }
}
`;
exports.GQL_CREATE_STORY_TAG_FOR_STUDIO = `
mutation createStoryTagForStudio($data: StoryTagCreationInput!) {
  createStoryTagForStudio(data: $data) {
    storyTagId
    name
  }
} 
`;
exports.GQL_SEARCH_STORY_TAG_FOR_STUDIO = `
query searchStoryTagForStudio($data: SearchStoryTagInput!) {
  searchStoryTagForStudio(data: $data) {
    storyTagId
    name
  }
}
`;
//
// Story Game Tabs Admin
//
const defaultStoryGameTab = `
    storygameTabId
    displayTitle
    showOrder
    isHidden
    type
    genre
`;
const defaultStoryGameSection = `
    storygameSectionId
    tabId
    title
    uiType
    isHidden
    algorithm
    sectionTitle
    numVisibleContents
    period
    hasViewMore
    isTestSection
    testSectionPercentage
    pinnedStorygameIds
    banners
    rankListSections
    showOrder
    sectionType
    sectionPosition
    sectionPositionOrder
    disabled
    supportedCountries {
      countryCode
      allowed
    }
    showReleaseDate
`;
exports.GQL_GET_ALL_STORY_GAME_TABS = `
  query {
    getAllStorygameTabs {
      ${defaultStoryGameTab}
    }
  }
`;
exports.GQL_UPDATE_STORY_GAME_TAB_ORDER = `
  mutation updateStorygameTabOrder($data: UpdateStorygameTabOrderInput!) {
    updateStorygameTabOrder(data: $data) {
      ${defaultStoryGameTab}
    }
  }
`;
exports.GQL_GET_ALL_STORY_GAME_SECTIONS = `
  query getAllStorygameSections($data: SingleIDInput!) {
    getAllStorygameSections(data: $data) {
      ${defaultStoryGameSection}
      pinnedStorygames {
        storyId
        name
      }
    }
  }
`;
const storyGameSectionPinnedStoryGamesDetail = `
  storyId
  name
  supportedStorygameSectionCountries(data: $sectionId) {
    countryCode
    disabled
    allowed
  }
  supportedStorygameSectionLanguages(data: $sectionId) {
    languageCode
    allowed
  }
  showInStorygameSection(data: $sectionId)
  publishedAt
  willPublishAt
`;
exports.GQL_GET_STORY_GAME_SECTION = `
  query getStorygameSection($data: SingleIDInput!, $sectionId: SingleIDInput!) {
    getStorygameSection(data: $data) {
      ${defaultStoryGameSection}
      pinnedStorygames {
        ${storyGameSectionPinnedStoryGamesDetail}
      }
    }
  }
`;
exports.GQL_CREATE_STORY_GAME_SECTION = `
  mutation createStorygameSection($data: StorygameSectionCreationInput!) {
    createStorygameSection(data: $data) {
      ${defaultStoryGameSection}
      pinnedStorygames {
        storyId
        name
      }      
    }
  }
`;
exports.GQL_UPDATE_STORY_GAME_SECTION = `
  mutation updateStorygameSection($data: StorygameSectionUpdateInput!, $sectionId: SingleIDInput!) {
    updateStorygameSection(data: $data) {
      ${defaultStoryGameSection}
      pinnedStorygames {
        ${storyGameSectionPinnedStoryGamesDetail}
      }            
    }
  }
`;
exports.GQL_REMOVE_STORY_GAME_SECTION = `
  mutation removeStorygameSection($data: SingleIDInput!) {
    removeStorygameSection(data: $data) {
      ok
    }
  }
`;
exports.GQL_UPDATE_STORY_GAME_SECTION_ORDER = `
  mutation updateStorygameSectionOrder($data: UpdateStorygameSectionOrderInput!) {
    updateStorygameSectionOrder(data: $data) {
      ${defaultStoryGameSection}
      pinnedStorygames {
        storyId
        name
      }      
    }
  }
`;
exports.GQL_TOGGLE_STORY_GAME_SECTION_COUNTRY = `
  mutation toggleStorygameSectionCountry($data: ToggleStorygameSectionCountry!) {
    toggleStorygameSectionCountry(data: $data) {
      ok
    }
  }
`;
exports.GQL_CREATE_IMAGE_FILE = `
  mutation createImageFile($data: ImageFileCreationInput!) {
    createImageFile(data: $data) {
      fileId
      width
      height
      link
    }
  }
`;
exports.GQL_GET_IMAGE_FILE = `
  query getImageFile($data: SingleIDInput!) {
    getImageFile(data: $data) {
      fileId
      width
      height
      link
    }
  }
`;
exports.GQL_PUBLISH_STORY_GAME_SECTION = `
  mutation publishStorygameSection {
    publishStorygameSections {
      ok
    }
  }
`;
exports.GQL_GET_ALL_STORY_GAME_SECTION_PREVIEWS = `
  query getAllStorygameSectionPreviews($data: GetAllStorygameSectionPreviewsInput!) {
    getAllStorygameSectionPreviews(data: $data) {
      sectionTitle
      sectionData
      uiType
      sectionId
      showReleaseDate
      hasViewMore
      isTestSection
      sectionType
    }
  }
`;
exports.GQL_TOGGLE_STORY_GAME_COUNTRY = `
  mutation toggleStorygameCountry($data: ToggleStorygameCountry!) {
    toggleStorygameCountry(data: $data) {
      ok
    }
  }
`;
exports.GQL_TOGGLE_STORY_GAME_LANGUAGE = `
  mutation toggleStorygameLanguage($data: ToggleStorygameLanguage!) {
    toggleStorygameLanguage(data: $data) {
      ok
    }
  }
`;
exports.GQL_TOGGLE_STORY_GAME_VISIBILITY = `
  mutation toggleStorygameVisibility($data: ToggleStorygameVisibilityInput!) {
    toggleStorygameVisibility(data: $data) {
      ok
    }
  }
`;
exports.GQL_GET_STORY_SIMPLE_INFO = `
query getStory($data: SingleIDInput!) {
  getStoryV3(data: $data) {
    storyId
    name
  }
}`;
